import { UserMultiValuedList } from '../../../User'
import { ListCell } from '../ListCell'

function TableUserListCell({
  List = UserMultiValuedList,
  disabled,
  listProps,
  ...restProps
}) {
  return (
    <ListCell
      {...restProps}
      List={List}
      listProps={{ ...listProps, disabled }}
    />
  )
}

export default TableUserListCell
